import Image from 'next/image'
import { type FC } from 'react'

import { AutocanBadgeImageIcon } from '@/components/vip/vip-autocan-features/styled'
import { type AutocanFeatureConfig } from '@/components/vip/vip-autocan-features/utils'

type BadgeWithListingImageProps = Pick<AutocanFeatureConfig, 'icon'> & {
  listingImage: NonNullable<AutocanFeatureConfig['listingImage']>
  useInlineVariant: boolean
}

/**
 * Image component for the autocan badge when it is dynamic based on the listing
 */
export const BadgeWithListingImage: FC<BadgeWithListingImageProps> = ({
  icon,
  listingImage,
  useInlineVariant,
}) => {
  return (
    <>
      <Image src={listingImage} alt="" fill data-testid="autocan-badge-listing-image" />

      {icon ? (
        <AutocanBadgeImageIcon
          alt=""
          height={56}
          src={icon}
          $useInlineVariant={useInlineVariant}
          width={56}
          data-testid="autocan-badge-desktop-icon"
        />
      ) : null}
    </>
  )
}
